module.exports = __webpack_public_path__ + "static/media/visitor.a35861a4.svg";